<script setup lang="ts">
import type { SelectGroupProps } from "./select.types";
import { useSharedState } from "composables/useSharedState";

defineOptions({ name: "SelectGroup" });

const props = defineProps<SelectGroupProps>();

useSharedState(props);
</script>

<template>
  <e-listbox-group class="e-select-group" :label="props.label">
    <slot />
  </e-listbox-group>
</template>

<style>
:host {
  display: contents;
}
</style>
